import AuthService from "../../services/AuthService";
import TokenService from "../../services/TokenService";
import hubConnection from "@/utils/signalrHub";

const user = JSON.parse(localStorage.getItem("user"));
const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: { loggedIn: false }, user: null };

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    async login({ commit }, payload) {
      return AuthService.login(payload).then(
        (user) => {
          commit("loginSuccess", user);
          //dispatch("menu/montarMenu", user, { root: true });
          return Promise.resolve(user);
        },
        (error) => {
          commit("loginFailure");
          return Promise.reject(error);
        }
      );
    },
    logout({ commit }) {
      if (localStorage.getItem("user")) {
        let user = JSON.parse(localStorage.getItem("user"));
        hubConnection.connection.invoke(
          "DesconectarSessao",
          user.RefreshToken,
          user.User.id
        );
      }
      AuthService.logout();
      commit("logout");
    },
    revokeSession({ commit }, payload) {
      return AuthService.RevokeSession(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    revokeSessionId({ commit }, payload) {
      return AuthService.RevokeSessionId(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    refreshTokenEmpresa({ commit }, payload) {
      return AuthService.RefreshTokenEmpresa(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {
    loginSuccess(state, user) {
      state.status.loggedIn = true;
      state.user = user;
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
  },
  getters: {},
};
